// Generated on 2026-06-06T17:30:00.282Z
// This file contains preloaded vehicles models data from the API
// Do not edit manually - use 'npm run generate:vehicles-models-data' to regenerate

export const preloadedVehiclesModels: any = [
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "117919"
  },
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "116491"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "104209"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "86972"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "76128"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "34742"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "34254"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "27742"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "27520"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "22945"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "22622"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "22180"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "20016"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "16260"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "15399"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "14532"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "13179"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "13032"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "13004"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "12286"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "10965"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "10532"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "10442"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "9876"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "9644"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "9187"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "9089"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "8769"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "8451"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "8112"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "8085"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "7966"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "7677"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "7623"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "6308"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "5904"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "5691"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "5615"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "5510"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "5415"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "5381"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "4632"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "4564"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "4477"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "4292"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "3795"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "3752"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "3502"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "3430"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "3397"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "3387"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "3379"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "3288"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "3286"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "3265"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "3182"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "3160"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "3062"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "2975"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "2795"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "2684"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "2620"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "2459"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "2422"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "2383"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "2238"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "2204"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "2181"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "2167"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "2167"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "2078"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "2069"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "2031"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "1983"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "1947"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "1940"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "1911"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "1887"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "1833"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "1748"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "1721"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "1710"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "1701"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "1688"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "1651"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "1635"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "1596"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "1585"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "1578"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "1563"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "1549"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "1536"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "1516"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "1451"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "1436"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "1380"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "1364"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "1343"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "1275"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "1275"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "1252"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "1238"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "1225"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "1147"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "974"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "951"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "948"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "943"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "940"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "918"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "913"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "894"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "860"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "843"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "806"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "792"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "783"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "780"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "771"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "764"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "760"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "752"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "751"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "750"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "744"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "740"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "693"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "689"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "671"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "667"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "662"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "646"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "646"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "645"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "629"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "625"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "600"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "573"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "565"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "558"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "545"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "532"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "530"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "526"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "523"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "502"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "500"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "494"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "492"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "473"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "460"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "460"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "458"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "453"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "450"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "445"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "439"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "434"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "423"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "415"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "412"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "400"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "399"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "388"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "388"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "388"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "384"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "378"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "376"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "372"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "368"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "365"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "356"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "352"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "351"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "350"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "344"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "344"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "344"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "340"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "336"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "330"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "320"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "319"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "311"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "301"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "299"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "295"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "293"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "293"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "291"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "290"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "289"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "273"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "273"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "267"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "266"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "265"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "265"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "262"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "261"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "257"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "252"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "249"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "245"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "245"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "242"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "242"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "240"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "235"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "227"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "225"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "217"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "208"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "206"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "201"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "199"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "196"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "190"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "188"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "187"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "182"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "181"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "181"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "178"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "178"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "178"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "176"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "176"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "175"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "173"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "172"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "171"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "167"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "164"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "163"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "162"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "157"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "156"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "156"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "156"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "153"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "150"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "149"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "148"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "147"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "144"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "141"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "140"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "138"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "137"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "137"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "136"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "135"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "135"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "130"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "128"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "123"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "123"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "120"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "118"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "117"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "116"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "116"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "113"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "113"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "112"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "108"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "104"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "103"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "101"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "99"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "99"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "98"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "98"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "95"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "95"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "94"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "93"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "93"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "92"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "91"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "91"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "91"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "91"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "90"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "89"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "88"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "88"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "87"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "87"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "84"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "81"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "81"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "81"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "81"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "80"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "79"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "78"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "77"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "77"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "76"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "76"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "75"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "74"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "74"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "73"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "73"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "73"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "73"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "72"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "71"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "70"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "70"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "69"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "69"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "69"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "69"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "67"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "66"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "66"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "65"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "65"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "65"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "64"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "64"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "64"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "64"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "64"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "62"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "61"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "61"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "60"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "59"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "58"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "58"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "57"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "56"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "56"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "55"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "54"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "52"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "51"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "51"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "50"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "50"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "50"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "49"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "49"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "49"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "49"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "49"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "48"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "48"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "48"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "47"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "47"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "46"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "45"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "45"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "44"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "44"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "43"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "42"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "42"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "42"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "42"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "42"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "42"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "41"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "41"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "41"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "41"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "41"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "40"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "39"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "39"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "38"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "38"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "38"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "38"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "38"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "38"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "38"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "37"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "37"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "37"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "37"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "36"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "36"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "35"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "35"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "35"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "35"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "35"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "34"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "34"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "34"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "34"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "33"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "33"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "33"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "32"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "32"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "31"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "31"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "31"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "30"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "30"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "30"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "30"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "29"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "29"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "29"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "28"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "28"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "28"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "28"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "27"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "27"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "27"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "26"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "26"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "26"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "26"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "26"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "25"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "25"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "25"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "25"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "25"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "25"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "25"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "25"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "25"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "24"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "24"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "24"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "23"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "23"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "23"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "23"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "23"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "23"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "22"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "22"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "21"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "21"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "21"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "21"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "21"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "20"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "20"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "20"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "20"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "20"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "20"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "18"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "18"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "18"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "18"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "18"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "17"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "17"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "17"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "17"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "17"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "17"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "17"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "17"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "16"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "16"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "16"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "16"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "16"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "15"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "15"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "15"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "15"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "15"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "14"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "13"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "13"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "13"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "13"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "13"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "13"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "13"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "12"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "740I",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "12"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "12"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FESTIVA",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "12"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "12"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "12"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "11"
  },
  {
    "marca": "BMW",
    "modelo": "335I XDRIVE",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "11"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "11"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "11"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "11"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "10"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "10"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "10"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ERTIGA",
    "busquedas": "10"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "10"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "10"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC DEL SOL",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "10"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "9"
  },
  {
    "marca": "FOTON",
    "modelo": "TUNLAND",
    "busquedas": "9"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "9"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "9"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "9"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "9"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "9"
  },
  {
    "marca": "JMC",
    "modelo": "GRAND AVENUE",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK500",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "325E",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "8"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S350",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "8"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "8"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "8"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "328D XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "7"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "7"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "7"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "7"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX400H",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "7"
  },
  {
    "marca": "AUDI",
    "modelo": "A5 QUATTRO",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "7"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ROUTAN",
    "busquedas": "7"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "KONA",
    "busquedas": "7"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "7"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "6"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SW1",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "6"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "6"
  },
  {
    "marca": "AUDI",
    "modelo": "A6",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "6"
  },
  {
    "marca": "ZNA",
    "modelo": "RICH 6",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "6"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "6"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "6"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "6"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "BMW",
    "modelo": "550I XDRIVE",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "GR86",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS350",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL550",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STARIA",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS PLAY",
    "busquedas": "5"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "5"
  },
  {
    "marca": "SUZUKI",
    "modelo": "DZIRE",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "5"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500 SUBURBAN",
    "busquedas": "5"
  },
  {
    "marca": "BMW",
    "modelo": "318TI",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "5"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "T6",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "M2",
    "busquedas": "4"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "4"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XTS",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 50",
    "busquedas": "4"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "XPANDER CROSS",
    "busquedas": "4"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "4"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "ASPEN",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "4"
  },
  {
    "marca": "BUICK",
    "modelo": "LUCERNE",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "4"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 3500",
    "busquedas": "4"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "4"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKZ",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "4"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "4"
  },
  {
    "marca": "SATURN",
    "modelo": "LS",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "POLICE INTERCEPTOR UTILITY",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 2500",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML430",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "LOYALE",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK320",
    "busquedas": "3"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40",
    "busquedas": "3"
  },
  {
    "marca": "ACURA",
    "modelo": "CL",
    "busquedas": "3"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE L",
    "busquedas": "3"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "3"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "CHANGAN",
    "modelo": "CM10",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "3"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "3"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA CRUZ",
    "busquedas": "3"
  },
  {
    "marca": "AUDI",
    "modelo": "Q3",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON XL 1500",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "190D",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "2"
  },
  {
    "marca": "SUBARU",
    "modelo": "JUSTY",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "750I",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CIAZ",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "LIANA",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "TESLA",
    "modelo": "S",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "C-HR",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "MONTANA",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "330I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "FIREBIRD",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS200",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "TEMPO",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX550",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER VELAR",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "530XI",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "TOWNER",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "PRIDE",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "CIVILIAN",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "K3",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "CORDIA",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF R",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CL500",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-TYPE",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 2 PRO",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "M35",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC40",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE LIMITED",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q70L",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SYCLONE",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300SDL",
    "busquedas": "2"
  },
  {
    "marca": "AUDI",
    "modelo": "A3 QUATTRO",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "340I XDRIVE",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "R32",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "ISUZU",
    "modelo": "ASCENDER",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "NX",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "NAVAJO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "230I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C10 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CLARITY",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUMINA",
    "busquedas": "1"
  },
  {
    "marca": "JAGUAR",
    "modelo": "F-PACE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "modelo": "FORTWO",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "LEXUS",
    "modelo": "SC430",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSICA",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "I8",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD CROSSTOUR",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "D250",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S500",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER CITY",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 3500",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "Y",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A5",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q40",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "500X",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "K1500",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-CROSS",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I GT",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L200",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "EOS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "228I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "V1500 SUBURBAN",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "L300",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "MINIBUS",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "MILAN",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF SPORTWAGEN",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CATERA",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "90 QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "300ZX",
    "busquedas": "1"
  },
  {
    "marca": "MERCURY",
    "modelo": "CAPRI",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "G63 AMG",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "SUBARU",
    "modelo": "DL",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER EXT",
    "busquedas": "1"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV3500",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "CROWN VICTORIA",
    "busquedas": "1"
  }
];

export default preloadedVehiclesModels;
